import React, {forwardRef, useEffect, useImperativeHandle} from 'react';
import {connect} from 'react-redux';
import PropTypes from 'prop-types';
import {bindActionCreators} from 'redux';
import withIntl from '../../../lib/withIntl';
import '../SetupWizard.scss';
import SetupWizardGeneralStepPage from './SetupWizardGeneralStepPage';
import {handleEjectTray} from '../../../stores/business/setupWizardBusiness/setupWizardInstrumentBusiness';
import {PlateCopyProtocolSubstep} from '../../../constants/SetupWizardEnum';
import {executeSetupWizardProtocol} from '../../../stores/business/setupWizardBusiness/setupWizardBusiness';
import {hideLoading} from '../../../stores/actions/appStateAction';
import {checkIsInstrumentIdle} from '../../../stores/business/instrumentStatusBusiness';

const mapStateToProps = (state) => ({
  loadingAppState: state.appState.loading,
});

const mapDispatchToProps = (dispatch) => ({
  SWInstrumentBusinessHandleEjectTray: bindActionCreators(handleEjectTray, dispatch),
  setupWizardBusinessRunProtocol: bindActionCreators(executeSetupWizardProtocol, dispatch),
  instrumentStatusBusinessCheckIsInstrumentIdle: bindActionCreators(checkIsInstrumentIdle, dispatch),
  appStateActionHideLoading: bindActionCreators(hideLoading, dispatch),
});

const StepSevenSetupWizard = forwardRef(
  (
    {
      instrumentStatusBusinessCheckIsInstrumentIdle,
      appStateActionHideLoading,
      SWInstrumentBusinessHandleEjectTray,
      setupWizardBusinessRunProtocol,
      loadingAppState,
      stepData,
    },
    ref,
  ) => {
    const {currentSubstep} = stepData;

    const checkRunningProtocol = async () => {
      if (loadingAppState.show) {
        const isInstrumentIdle = await instrumentStatusBusinessCheckIsInstrumentIdle(true);

        if (isInstrumentIdle) {
          appStateActionHideLoading();
        }
      }
    };

    const onButtonClick = () => setupWizardBusinessRunProtocol();

    const onBack = async () => {
      if (currentSubstep === PlateCopyProtocolSubstep.RUN_PROTOCOL) {
        SWInstrumentBusinessHandleEjectTray();
      }
    };

    useImperativeHandle(ref, () => ({
      onBack,
    }));

    useEffect(() => {
      checkRunningProtocol();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps

    return (
      <SetupWizardGeneralStepPage
        onButtonClick={currentSubstep === PlateCopyProtocolSubstep.RUN_PROTOCOL ? onButtonClick : null}
        buttonProps={{
          type: 'positive',
          variant: 'contain',
        }}
        withImageCaption={!(currentSubstep === PlateCopyProtocolSubstep.RUN_PROTOCOL)}
      />
    );
  },
);

StepSevenSetupWizard.propTypes = {
  instrumentStatusBusinessCheckIsInstrumentIdle: PropTypes.func.isRequired,
  appStateActionHideLoading: PropTypes.func.isRequired,
  SWInstrumentBusinessHandleEjectTray: PropTypes.func.isRequired,
  setupWizardBusinessRunProtocol: PropTypes.func.isRequired,
  loadingAppState: PropTypes.object.isRequired,
  stepData: PropTypes.object.isRequired,
};

export default connect(mapStateToProps, mapDispatchToProps, null, {forwardRef: true})(withIntl(StepSevenSetupWizard));
